import {DateTimeService} from 'src/app/core/utils/datetime.service';
import {ConyugeFormularioModel} from '../../../../components/cambio-estado-civil/exponer-informacion/conyuge-form';
import {CambioEstadoCivilEnum} from '../../../enums/cambio-estado-civil-enum';
import {Complementos} from './complementos.model';
import {DatosBasicos} from './datos-basicos.model';
import {DatosContacto} from './datos-contacto.model';
import {Empresa} from './empresa.model';
import {Identidad} from './identidad.model';
import {InformacionLaboral} from './info-laboral.model';
import {Parentesco} from './parentesco.model';
import {agregarDocumentoRNEC, agregarDocumentosNoExigibles, mapearASolicitudDocumentos} from './solicitud-documentos-mapper';
import {SolicitudTiposEnum} from './solicitud-tipos.enum';

export class ConyugeModel {
  public identidad = Identidad.instance();
  public motivo?: any;
  public origen: any;
  public datosBasicos = DatosBasicos.instance();
  public fechaExpedicion: string;
  public nacionalidad: string;
  public infoLaboral = InformacionLaboral.instance();
  public empresa = Empresa.instance();
  public datosContacto = DatosContacto.instance();
  public ocupacion: string;
  public cuidador: boolean;
  public parentesco = Parentesco.instance();
  public complementos: Complementos[] = [];

  static mapearDesdeFormularioAFT(solicitudTipo: SolicitudTiposEnum, conyugeForm: any) {
    const conyugeDto = ConyugeModel.instance();

    if (!conyugeForm)
      return conyugeDto;

    conyugeDto.identidad.tipo = conyugeForm["TipoIdConyuge"] || "";
    conyugeDto.identidad.numero = conyugeForm["NumIdConyuge"] || "";
    conyugeDto.ocupacion = conyugeForm["OcupacionConyuge"] || "";
    conyugeDto.cuidador = conyugeForm["CuidadorConyuge"] || false;
    conyugeDto.parentesco = { tipoParentesco: "CONYUGE", codigoParentesco: "SUB-0002" };
    conyugeDto.fechaExpedicion = conyugeForm["FechaExpedicionConyuge"] || "";
    conyugeDto.nacionalidad = conyugeForm["NacionalidadConyuge"] || "CO";

    conyugeDto.datosBasicos = {
      primerNombre: conyugeForm["Nombre1Conyuge"] || "",
      segundoNombre: conyugeForm["Nombre2Conyuge"] || "",
      primerApellido: conyugeForm["Apellido1Conyuge"] || "",
      segundoApellido: conyugeForm["Apellido2Conyuge"] || "",
      edad: DateTimeService.calcularEdad(conyugeForm["FechaNaciConyuge"]),
      genero: conyugeForm["GeneroConyuge"] || "",
      fechaNacimiento: conyugeForm["FechaNaciConyuge"] || "",
    }

    conyugeDto.infoLaboral.tipo = conyugeForm["TipoActividadConyuge"] || "";
    conyugeDto.infoLaboral.ingresos = {
      salario: {
        tipo: conyugeForm["TipoSalarioConyuge"] || "",
        basico: conyugeForm["SalarioConyuge"] || ""
      }
    }

    conyugeDto.infoLaboral.contrato = {
      tipo: conyugeForm["TipoContratoConyuge"] || "",
      horasDiaria: conyugeForm["HorasDiariaConyuge"] || "",
      horasMes: conyugeForm["HorasMesConyuge"] || "",
      fechaIngreso: conyugeForm["FechaIngresoConyuge"] || ""
    }

    conyugeDto.datosContacto = {
      correoElectronico: conyugeForm["CorreoElectronicoConyuge"] || "",
      celular: conyugeForm["CelularConyuge"] || "",
      telefono: conyugeForm["TelefonoConyuge"] || ""
    };

    conyugeDto.empresa.identidad = {
      tipo: conyugeForm["TipoIdEmpresaConyuge"] || "",
      numero: conyugeForm["NumIdEmpresaConyuge"] || ""
    };
    conyugeDto.empresa.razonSocial = conyugeForm["RazonEmpresaConyuge"] || "";
    conyugeDto.empresa.digitoVerificador = conyugeForm["DigVerEmpresaConyuge"] || "";
    conyugeDto.empresa.correoElectronico = "";


    let complementos: Array<any> = mapearASolicitudDocumentos(solicitudTipo, conyugeForm["documents"]);
    agregarDocumentoRNEC(solicitudTipo, conyugeForm["base64Valid"], complementos);
    agregarDocumentosNoExigibles(solicitudTipo, conyugeForm["documentsNoExigibles"], complementos);

    conyugeDto.complementos = complementos;
    return conyugeDto;
  }

  static mapearDesdeFormularioCEC(conyugeForm: ConyugeFormularioModel, docMapForm: any, cambioEstado?: any, esatdoCivilInicial?: any): ConyugeModel {
    const contratoApi = ConyugeModel.instance();

    contratoApi.identidad.tipo = conyugeForm?.["TipoIdConyuge"]?.toString() || "";
    contratoApi.identidad.numero = conyugeForm?.["NumIdConyuge"]?.toString() || "";
    contratoApi.ocupacion = conyugeForm?.["OcupacionConyuge"]?.toString() || "01";
    contratoApi.cuidador = conyugeForm["CuidadorConyuge"] || false;
    contratoApi.parentesco = { tipoParentesco: "CONYUGE", codigoParentesco: "SUB-0002" };
    contratoApi.fechaExpedicion = conyugeForm?.["FechaExpedicionConyuge"] || "";
    contratoApi.nacionalidad = conyugeForm?.["NacionalidadConyuge"] || null;

    contratoApi.datosBasicos = {
      primerNombre: conyugeForm?.["Nombre1Conyuge"] || "",
      segundoNombre: conyugeForm?.["Nombre2Conyuge"] || "",
      primerApellido: conyugeForm?.["Apellido1Conyuge"] || "",
      segundoApellido: conyugeForm?.["Apellido2Conyuge"] || "",
      edad: conyugeForm?.["FechaNaciConyuge"] ? DateTimeService.calcularEdad(new Date(conyugeForm["FechaNaciConyuge"])) : null,
      genero: conyugeForm?.["GeneroConyuge"] || "",
      fechaNacimiento: conyugeForm?.["FechaNaciConyuge"] || "",
    };

    contratoApi.infoLaboral.tipo = conyugeForm?.["OcupacionConyuge"] || "";
    contratoApi.infoLaboral = {
      tipo: conyugeForm?.OcupacionConyuge || "01",
      ingresos: {
        salario: {
          tipo: conyugeForm?.["TipoSalarioConyuge"] || "",
          basico: conyugeForm?.["SalarioConyuge"] || "",
        }
      },
      contrato: {
        tipo: "",
        horasDiaria: "",
        horasMes: "",
        fechaIngreso: ""
      }
    };

    contratoApi.nacionalidad = "CO";

    contratoApi.empresa = {
      identidad: {
        tipo: conyugeForm?.["TipoIdEmpresaConyuge"]?.toString() || "",
        numero: conyugeForm?.["NumIdEmpresaConyuge"]?.toString() || ""
      },
      digitoVerificador: conyugeForm?.["DigVerEmpresaConyuge"]?.toString() || "",
      razonSocial: conyugeForm?.["RazonEmpresaConyuge"]?.toString() || "",
      correoElectronico: ""
    };

    let estadoCivil = parseInt(cambioEstado) || 0;
    let estadoCivilInicial = parseInt(esatdoCivilInicial) || 0;
    contratoApi.motivo = estadoCivil?.toString();
    contratoApi.origen = estadoCivilInicial?.toString();


    const solicitudTipo = ConyugeModel.calcularSolicitudTipoDesdeNuevoEstadoCivil(estadoCivil, estadoCivilInicial);
    let complementos: Array<any> = mapearASolicitudDocumentos(solicitudTipo, docMapForm?.["documents"] || []);
    if (conyugeForm["base64Valid"]) {
      agregarDocumentoRNEC(solicitudTipo, conyugeForm["base64Valid"], complementos, false, false);
    }

    if (conyugeForm["documentsNoExigibles"]) {
      agregarDocumentosNoExigibles(
        solicitudTipo,
        conyugeForm["documentsNoExigibles"],
        complementos
      );
    }

    contratoApi.complementos = complementos;

    return contratoApi;
  }

  static calcularSolicitudTipoDesdeNuevoEstadoCivil(
    nuevoEstadoCivil: CambioEstadoCivilEnum,
    estadoCivilInicial: CambioEstadoCivilEnum
  ): SolicitudTiposEnum  {

    const AFB_TRANSITIONS = new Set<string>([
      `${CambioEstadoCivilEnum.SINGLE}->${CambioEstadoCivilEnum.FREE_UNION}`,
      `${CambioEstadoCivilEnum.SINGLE}->${CambioEstadoCivilEnum.MARRIED}`,
      `${CambioEstadoCivilEnum.SEPARATED}->${CambioEstadoCivilEnum.FREE_UNION}`,
      `${CambioEstadoCivilEnum.SEPARATED}->${CambioEstadoCivilEnum.MARRIED}`,
      `${CambioEstadoCivilEnum.WIDOWER}->${CambioEstadoCivilEnum.FREE_UNION}`,
      `${CambioEstadoCivilEnum.WIDOWER}->${CambioEstadoCivilEnum.MARRIED}`,
    ]);

    const RIB_TRANSITIONS = new Set<string>([
      `${CambioEstadoCivilEnum.MARRIED}->${CambioEstadoCivilEnum.SEPARATED}`,
      `${CambioEstadoCivilEnum.FREE_UNION}->${CambioEstadoCivilEnum.SEPARATED}`,
      `${CambioEstadoCivilEnum.MARRIED}->${CambioEstadoCivilEnum.WIDOWER}`,
      `${CambioEstadoCivilEnum.FREE_UNION}->${CambioEstadoCivilEnum.WIDOWER}`,
    ]);

    const CEC_TRANSITIONS = new Set<string>([
      `${CambioEstadoCivilEnum.FREE_UNION}->${CambioEstadoCivilEnum.MARRIED}`,
    ]);

    const key = `${estadoCivilInicial}->${nuevoEstadoCivil}`;

    if (AFB_TRANSITIONS.has(key)) {
      return SolicitudTiposEnum.AFB;
    }

    if (RIB_TRANSITIONS.has(key)) {
      return SolicitudTiposEnum.RIB;
    }
    if (CEC_TRANSITIONS.has(key)) {
      return SolicitudTiposEnum.CEC;
    }
    return SolicitudTiposEnum.CEC;
  }

  static instance() {
    return new this();
  }
}
